var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "config-item__quantity d-flex align-items-center@medium" },
      [
        _c(
          "button",
          {
            staticClass: "btn btn--square btn--icon",
            attrs: { type: "button" },
            on: { click: _vm.minus },
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm._f("translate")("txtMinus"))),
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "svg-icon svg-icon--large",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 36 36",
                },
              },
              [
                _c("circle", {
                  attrs: { cx: "18", cy: "18", r: "18", fill: "#3a3a39" },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M25.51 17H10.49c-.54 0-.98.44-.98.98s.44.98.98.98h15.02c.54 0 .98-.44.98-.98s-.44-.98-.98-.98z",
                    fill: "#fff",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "input--small",
          attrs: { type: "number", min: "1" },
          domProps: { value: _vm.inputValue },
          on: { input: _vm.validate },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn--square btn--icon",
            attrs: { type: "button" },
            on: { click: _vm.plus },
          },
          [
            _c("span", { staticClass: "sr-only" }, [
              _vm._v(_vm._s(_vm._f("translate")("txtPlus"))),
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "svg-icon svg-icon--large",
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 36 36",
                },
              },
              [
                _c("circle", {
                  attrs: { cx: "18", cy: "18", r: "18", fill: "#3a3a39" },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M25.51 17.03h-6.54v-6.54c0-.54-.44-.98-.98-.98s-.98.44-.98.98v6.54h-6.53c-.54 0-.98.44-.98.98s.44.98.98.98h6.53v6.54c0 .54.44.98.98.98s.98-.44.98-.98v-6.54h6.54c.54 0 .98-.44.98-.98s-.44-.98-.98-.98z",
                    fill: "#fff",
                  },
                }),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }